import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, CheckSquare, FileText } from 'lucide-react'; // Dynamic dashboard icons
import '../admin/admin_dashboard.css';

const AdminDashboard = () => {
  const navigate = useNavigate();

  const menuItems = [
    {
      title: "Member List",
      description: "Manage registered users and track membership types",
      icon: <Users size={32} className="admin-icon" />,
      path: "/admin-parm/member-list"
    },
    {
      title: "Approval",
      description: "Review pending registrations, evaluate proposer approvals, and authorize secretarial status changes.",
      icon: <CheckSquare size={32} className="admin-icon" />,
      path: "/admin-parm/approval-member-list"
    },
    {
      title: "Content",
      description: "Update the past event archive portfolio, upload new images, and manage site configurations.",
      icon: <FileText size={32} className="admin-icon" />,
      path: "/admin-parm/content-dashboard-parm"
    }
  ];

  return (
    <section className="admin-dashboard-section">
      <div className="admin-dashboard-container">
        <header className="admin-dashboard-header">
          <span>PArM Management Suite</span>
          <h2>Administrative Control Center</h2>
          {/* <p>Select a specialized module below to oversee the Professional Association of Malaysia operations.</p> */}
        </header>

        {/* 🟢 Interactive Admin Core Control Grid */}
        <div className="admin-menu-grid">
          {menuItems.map((item, index) => (
            <div 
              key={index} 
              className="admin-menu-card"
              onClick={() => navigate(item.path)}
            >
              <div className="admin-icon-wrapper">
                {item.icon}
              </div>
              <div className="admin-card-info">
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
              <div className="admin-card-footer">
                <span>Enter Module ➔</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AdminDashboard;